import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';
import { REGISTRADO, ANULADO, IMPORTADO } from '../../../common/types/importacionEstadoType';

export default function ResultList(props) {
    const renderColor = (row) => {
        if (row.idImportacionEstado === IMPORTADO)
            return 'blue';
        if (row.idImportacionEstado === REGISTRADO)
            return 'green';
        if (row.idImportacionEstado === ANULADO)
            return 'red';
    };

    return (
        <CustomTable
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">

                            <Tooltip placement="top" title="Ver">
                                <Button
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onVer(row, false)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Editar">
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    loading={props.loadingEdit}
                                    onClick={() => props.onEditar(row, true)}
                                    disabled={row.idImportacionEstado !== REGISTRADO ? true : false}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Anular">
                                <Button
                                    type="danger"
                                    icon="delete"
                                    size={"small"}
                                    onClick={() => props.onAnular(row)}
                                    disabled={row.idImportacionEstado === REGISTRADO ? false : true}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Imprimir">
                                <Button
                                    type="primary"
                                    icon="printer"
                                    size={"small"}
                                    onClick={() => props.onImprimir(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Documento',
                    dataIndex: 'documento',
                    key: 'documento',
                    sorter: true
                },
                {
                    title: 'Fecha',
                    dataIndex: 'fechaStr',
                    key: 'fechaStr',
                    sorter: true
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    sorter: true
                },
                {
                    title: 'Moneda',
                    dataIndex: 'nombreMoneda',
                    key: 'nombreMoneda',
                    sorter: true
                },
                {
                    title: 'Proyecto',
                    dataIndex: 'nombreProyecto',
                    key: 'nombreProyecto',
                    sorter: true
                },
                {
                    title: 'Almacen',
                    dataIndex: 'nombreAlmacen',
                    key: 'nombreAlmacen',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'nombreImportacionEstado',
                    key: 'nombreImportacionEstado',
                    align: 'center',
                    width: "90px",
                    fixed: 'right',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            <Tag color={renderColor(row)}>{value}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );

}
